import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { toast } from "react-toastify";
import "react-image-crop/dist/ReactCrop.css";
import { useTranslation } from "react-i18next";
import { authenticatedRequest } from "../../../config/axios";

const IDFSync = ({ setTabDisable }) => {
  const { t } = useTranslation();
  const lang = localStorage.getItem("lang");
  const [id, setId] = useState("");
  const [loading, setLoading] = useState(false);
  const [serverMessage, setServerMessage] = useState({ text: "", color: "" });

  const handleChange = (event) => {
    const { value } = event.target;
    setId(value);
    setServerMessage({ text: "", color: "" });
  };

  const validation = () => {
    let isValid = true;
    if (!id) {
      toast.error(t("Please enter meeting Id"), { toastId: "id" });
      return (isValid = false);
    }
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validation()) {
      return;
    }

    try {
      setLoading(true);
      setTabDisable(true);
      const response = await authenticatedRequest({
        method: "get",
        url: `admin/syncIDFMeeting/${id}`,
        headers: {
          "Content-Type": "application/json",
        },
      });
      if ([200].includes(response?.data?.responseCode)) {
        setServerMessage({
          text: "Meeting has been successfully sent",
          color: "#1E0F3C",
        });
        setLoading(false);
        setTabDisable(false);
        // handleIdfUpload();
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      setTabDisable(false);
      if (error.response.status === 417) {
        setServerMessage({
          text: error?.response?.data?.message,
          color: "red",
        });
      }
    }
  };
  return (
    <div className="idf-sync">
      <Form
        className={`idf-upload-form ${lang === "HE" ? "rtl-css" : ""}`}
        dir={lang === "HE" ? "rtl" : "ltr"}
        onSubmit={handleSubmit}
      >
        <Form.Group className="form-group">
          <Form.Label>{t("Meeting Id")}</Form.Label>
          <Form.Control
            className="form-control"
            type="text"
            placeholder={t("Enter Meeting Id")}
            value={id}
            id="meetingId"
            onChange={handleChange}
            autoComplete="off"
            name="meetingId"
          />
          {serverMessage.text && (
            <p
              style={{
                color: serverMessage.color,
                padding: "10px 0px",
                margin: 0,
                textAlign: "center",
                fontWeight: "600",
              }}
            >
              {serverMessage.text}
            </p>
          )}
        </Form.Group>

        <div className="submit-btn-grid">
          <Button className="download_report" type="submit" disabled={loading}>
            {t("Send")}
          </Button>
        </div>
      </Form>
    </div>
  );
};
export default IDFSync;
